// extracted by mini-css-extract-plugin
export var button = "_lb-2";
export var card = "_lb-0";
export var closeButtonContainer = "_lb-3";
export var iconContainer = "_lb-1";